import { render, staticRenderFns } from "./TopCustomersWidget.vue?vue&type=template&id=79f6c1b4&scoped=true"
import script from "./TopCustomersWidget.vue?vue&type=script&lang=ts"
export * from "./TopCustomersWidget.vue?vue&type=script&lang=ts"
import style0 from "./TopCustomersWidget.vue?vue&type=style&index=0&id=79f6c1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f6c1b4",
  null
  
)

export default component.exports